// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  // minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgotPassword`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    maintenance: {
      genders: {
        list: `${ROOTS.DASHBOARD}/maintenance/genders`,
        new: `${ROOTS.DASHBOARD}/maintenance/genders/new`,
      },
      countries: {
        list: `${ROOTS.DASHBOARD}/maintenance/countries`,
        new: `${ROOTS.DASHBOARD}/maintenance/countries/new`,
      },
      cancelReasons: {
        list: `${ROOTS.DASHBOARD}/maintenance/cancelReasons`,
        new: `${ROOTS.DASHBOARD}/maintenance/cancelReasons/new`,
      },
      apiSettings: {
        list: `${ROOTS.DASHBOARD}/maintenance/apiSettings`,
        new: `${ROOTS.DASHBOARD}/maintenance/apiSettings/new`,
      },
      statuses: {
        list: `${ROOTS.DASHBOARD}/maintenance/statuses`,
        new: `${ROOTS.DASHBOARD}/maintenance/statuses/new`,
      },
      deleteLocationCategoryEventReason: {
        list: `${ROOTS.DASHBOARD}/maintenance/deleteLocationCategoryEventReason`,
        new: `${ROOTS.DASHBOARD}/maintenance/deleteLocationCategoryEventReason/new`,
      },
      medals: {
        list: `${ROOTS.DASHBOARD}/maintenance/medals`,
        new: `${ROOTS.DASHBOARD}/maintenance/medals/new`,
      },
      clasifications: {
        list: `${ROOTS.DASHBOARD}/maintenance/clasifications`,
        new: `${ROOTS.DASHBOARD}/maintenance/clasifications/new`,
      },
    },
    configuration: {
      user: {
        new: `${ROOTS.DASHBOARD}/usuarios/new`,
        list: `${ROOTS.DASHBOARD}/usuarios`,
      },
      roles: {
        new: `${ROOTS.DASHBOARD}/roles/new`,
        list: `${ROOTS.DASHBOARD}/roles`,
      },
      relationRolService: {
        list: `${ROOTS.DASHBOARD}/ServiciosRol`,
      },
      branches: {
        list: `${ROOTS.DASHBOARD}/sucursales`,
        new: `${ROOTS.DASHBOARD}/sucursales/new`,
      },
      companies: {
        list: `${ROOTS.DASHBOARD}/empresas`,
        new: `${ROOTS.DASHBOARD}/empresas/new`,
      },
      products: {
        list: `${ROOTS.DASHBOARD}/productos`,
        new: `${ROOTS.DASHBOARD}/productos/new`,
      },
      orders: {
        list: `${ROOTS.DASHBOARD}/pedidos`,
        new: `${ROOTS.DASHBOARD}/pedidos/new`,
      },
      ordersHistory: {
        list: `${ROOTS.DASHBOARD}/historialPedidos`,
      },
      finance: {
        list: `${ROOTS.DASHBOARD}/finanzas`,
      },
    },
  },
};
